export function normalizeInvoiceStatus(
  status: string | null | undefined,
): string | null {
  if (!status || !status.trim()) return null;
  return status.trim().toLowerCase().replace(/_/g, ' ');
}

function isPaidInvoiceStatus(status: string | null | undefined): boolean {
  return normalizeInvoiceStatus(status) === 'paid';
}

function isPartiallyPaidInvoiceStatus(
  status: string | null | undefined,
): boolean {
  return normalizeInvoiceStatus(status) === 'partially paid';
}

/**
 * ENR-3102: invoice-only / scheduled posts create receivables without collecting.
 * Show Posted until the invoice is actually paid; Charged only when paid.
 */
export function resolvePostedOrChargedLabel(args: {
  isAlreadyProcessed?: boolean;
  isPartiallyProcessed?: boolean;
  invoiceStatus?: string | null;
}):
  | 'Charged'
  | 'Partially Charged'
  | 'Posted'
  | 'Partially Posted'
  | 'Not Charged' {
  if (args.isAlreadyProcessed) {
    if (isPaidInvoiceStatus(args.invoiceStatus)) return 'Charged';
    if (isPartiallyPaidInvoiceStatus(args.invoiceStatus)) {
      return 'Partially Charged';
    }
    return 'Posted';
  }

  if (args.isPartiallyProcessed) {
    if (isPaidInvoiceStatus(args.invoiceStatus)) return 'Partially Charged';
    return 'Partially Posted';
  }

  return 'Not Charged';
}
